import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/flecha-avanzar-red.svg";
import { setGroup } from "../redux/actions";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";


function Gameover({ intl }) {
  	const [loading, setLoading] = useState(false);

	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);
	const game = useSelector((state) => state.game);

	useEffect(() => {
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.RESULTS,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			});
		}
	}, []);

	const handleClick = (e, direction = "next") => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);

		getGameById(game?._id).then((res) => {
		  if (res.status === 200) {
			navigate(ROUTES.RESULTS);
		  } else {
			setLoading(false);
		  }
		});
	  };

	return (
		<div className="h-100 bgGameOver">
			<div className="container-fluid h-100">
				<div className="row h-100 d-flex align-items-end">
					<div className="d-flex justify-content-center align-items-center mb-5">
						<div className="txtBotonesWhite me-3">
							Ver resultados
						</div>
						<button
							onClick={(e) => handleClick(e, "next")}
							className="btn-main white btn-progress"
							data-loading={loading ? "true" : "false"}
							style={{ width: 80, height: 80, borderRadius: "50%" }}
							aria-busy={loading}
						>
							<img
							src={flechaAvanzar}
							alt="Ver resultados"
							style={{ maxWidth: "40px" }}
							/>
						</button>              
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Gameover);
